(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './coil-root-coil-network-core.js', './kotlin-kotlin-stdlib.js', './ktor-ktor-client-core.js', './coil-root-coil-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./coil-root-coil-network-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-client-core.js'), require('./coil-root-coil-core.js'));
  else {
    if (typeof globalThis['coil-root-coil-network-core'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-network-ktor3'. Its dependency 'coil-root-coil-network-core' was not found. Please, check whether 'coil-root-coil-network-core' is loaded prior to 'coil-root-coil-network-ktor3'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-network-ktor3'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'coil-root-coil-network-ktor3'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-network-ktor3'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'coil-root-coil-network-ktor3'.");
    }
    if (typeof globalThis['coil-root-coil-core'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-network-ktor3'. Its dependency 'coil-root-coil-core' was not found. Please, check whether 'coil-root-coil-core' is loaded prior to 'coil-root-coil-network-ktor3'.");
    }
    globalThis['coil-root-coil-network-ktor3'] = factory(typeof globalThis['coil-root-coil-network-ktor3'] === 'undefined' ? {} : globalThis['coil-root-coil-network-ktor3'], globalThis['coil-root-coil-network-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-client-core'], globalThis['coil-root-coil-core']);
  }
}(function (_, kotlin_io_coil_kt_coil3_coil_network_core, kotlin_kotlin, kotlin_io_ktor_ktor_client_core, kotlin_io_coil_kt_coil3_coil_core) {
  'use strict';
  //region block: imports
  var Factory = kotlin_io_coil_kt_coil3_coil_network_core.$_$.a;
  var Companion_getInstance = kotlin_io_coil_kt_coil3_coil_network_core.$_$.b;
  var VOID = kotlin_kotlin.$_$.d;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.c1;
  var protoOf = kotlin_kotlin.$_$.eh;
  var Uri = kotlin_io_coil_kt_coil3_coil_core.$_$.h;
  var getKClass = kotlin_kotlin.$_$.si;
  var FetcherServiceLoaderTarget = kotlin_io_coil_kt_coil3_coil_core.$_$.e;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var hashCode = kotlin_kotlin.$_$.bg;
  var equals = kotlin_kotlin.$_$.sf;
  var ServiceLoaderComponentRegistry_getInstance = kotlin_io_coil_kt_coil3_coil_core.$_$.i;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var defineProp = kotlin_kotlin.$_$.pf;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(KtorNetworkFetcherServiceLoaderTarget, 'KtorNetworkFetcherServiceLoaderTarget', KtorNetworkFetcherServiceLoaderTarget, VOID, [FetcherServiceLoaderTarget]);
  initMetadataForClass(KtorNetworkClient, 'KtorNetworkClient', VOID, VOID, VOID, [2]);
  //endregion
  function KtorNetworkFetcherFactory() {
    return new Factory(KtorNetworkFetcherFactory$lambda);
  }
  function asNetworkClient(_this__u8e3s4) {
    return new KtorNetworkClient(_KtorNetworkClient___init__impl__iiqcwc(_this__u8e3s4));
  }
  function KtorNetworkFetcherFactory_0(httpClient, concurrentRequestStrategy) {
    concurrentRequestStrategy = concurrentRequestStrategy === VOID ? Companion_getInstance().fxv_1 : concurrentRequestStrategy;
    var tmp = KtorNetworkFetcherFactory$lambda_0(httpClient);
    return new Factory(tmp, VOID, VOID, KtorNetworkFetcherFactory$lambda_1(concurrentRequestStrategy));
  }
  function KtorNetworkFetcherFactory$lambda() {
    return asNetworkClient(HttpClient());
  }
  function KtorNetworkFetcherFactory$lambda_0($httpClient) {
    return function () {
      return asNetworkClient($httpClient);
    };
  }
  function KtorNetworkFetcherFactory$lambda_1($concurrentRequestStrategy) {
    return function () {
      return $concurrentRequestStrategy;
    };
  }
  function KtorNetworkFetcherServiceLoaderTarget() {
  }
  protoOf(KtorNetworkFetcherServiceLoaderTarget).fxf = function () {
    return KtorNetworkFetcherFactory();
  };
  protoOf(KtorNetworkFetcherServiceLoaderTarget).gxf = function () {
    return getKClass(Uri);
  };
  protoOf(KtorNetworkFetcherServiceLoaderTarget).ixf = function () {
    return 1;
  };
  function _KtorNetworkClient___init__impl__iiqcwc(httpClient) {
    return httpClient;
  }
  function KtorNetworkClient__toString_impl_iu595g($this) {
    return 'KtorNetworkClient(httpClient=' + $this.toString() + ')';
  }
  function KtorNetworkClient__hashCode_impl_2x0nnf($this) {
    return hashCode($this);
  }
  function KtorNetworkClient__equals_impl_3j9gyn($this, other) {
    if (!(other instanceof KtorNetworkClient))
      return false;
    var tmp0_other_with_cast = other.pxv_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function KtorNetworkClient(httpClient) {
    this.pxv_1 = httpClient;
  }
  protoOf(KtorNetworkClient).toString = function () {
    return KtorNetworkClient__toString_impl_iu595g(this.pxv_1);
  };
  protoOf(KtorNetworkClient).hashCode = function () {
    return KtorNetworkClient__hashCode_impl_2x0nnf(this.pxv_1);
  };
  protoOf(KtorNetworkClient).equals = function (other) {
    return KtorNetworkClient__equals_impl_3j9gyn(this.pxv_1, other);
  };
  function get_initHook() {
    return initHook;
  }
  var initHook;
  function initHook$init$() {
    ServiceLoaderComponentRegistry_getInstance().jxk(new KtorNetworkFetcherServiceLoaderTarget());
    return Unit_instance;
  }
  //region block: eager init
  initHook = initHook$init$();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var coil3 = _.coil3 || (_.coil3 = {});
    var network = coil3.network || (coil3.network = {});
    var ktor3 = network.ktor3 || (network.ktor3 = {});
    var internal = ktor3.internal || (ktor3.internal = {});
    defineProp(internal, 'initHook', get_initHook, VOID, true);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = KtorNetworkFetcherFactory_0;
  //endregion
  return _;
}));

//# sourceMappingURL=coil-root-coil-network-ktor3.js.map
